<div [hidden]="currentType=='VOUCHER'">
  <mat-form-field >
    <mat-select [disabled]="disabled" [placeholder]="'ORDER.PAYMENT.TITLE' | translate" (selectionChange)="typeSelected($event)" [(ngModel)]="currentType"
      required>
      <mat-select-trigger>
        <div fxLayout="row">
          <div  *ngIf="currentType == 'CASH' || currentType == 'CREDIT_CARD' || currentType == 'SOFORT' || currentType == 'INVOICE'">
            <img *ngIf="currentType == 'INVOICE'" src="../../../../assets/img/payments/ueberweisung.jpg" class="payment-img" />
            <img *ngIf="currentType == 'CREDIT_CARD'" src="../../../../assets/img/payments/visa.jpg" class="payment-img" />
            <img *ngIf="currentType == 'SOFORT'" src="../../../../assets/img/payments/klarna.png" class="payment-img" />
            <img *ngIf="currentType == 'CASH'" src="../../../../assets/img/payments/nachnahme.png" class="payment-img" />
          </div>
          <div class="payment-text" *ngIf="currentType == 'INVOICE'">{{'ORDER.PAYMENT.FORM.'+ types.invoice | translate}}</div>
          <div class="payment-text" *ngIf="currentType == 'CREDIT_CARD'">{{'ORDER.PAYMENT.FORM.'+ types.creditcard | translate}}</div>
          <div class="payment-text" *ngIf="currentType == 'SOFORT'">{{'ORDER.PAYMENT.FORM.'+ types.sofort | translate}}</div>
          <div class="payment-text" *ngIf="currentType == 'CASH'">{{'ORDER.PAYMENT.FORM.'+ types.cashOnDelivery | translate}}</div>
          <div class="payment-text" *ngIf="currentType == 'VOUCHER'">{{'ORDER.PAYMENT.FORM.'+ types.voucher | translate}}</div>
          <div class="payment-text" *ngIf="currentType == 'NO_PAYMENT'">{{'ORDER.PAYMENT.FORM.'+ types.free | translate}}</div>
        </div>
      </mat-select-trigger>
      <mat-option *ngIf="!allowedPaymentMethods || allowedPaymentMethods.invoice" [value]="types.invoice">
        <div fxLayout="row">
          <div class="payment-img-container">
            <img src="../../../../assets/img/payments/ueberweisung.jpg" class="payment-img" />
          </div>
          <div class="payment-text">{{'ORDER.PAYMENT.FORM.'+ types.invoice | translate}}</div>
        </div>
      </mat-option>
      <mat-option *ngIf="!allowedPaymentMethods || allowedPaymentMethods.voucher"  [value]="types.voucher">
        <div fxLayout="row">
          <div class="payment-img-container">

          </div>
          <div class="payment-text">{{'ORDER.PAYMENT.FORM.'+ types.voucher | translate}}</div>
        </div>

      </mat-option>
      <mat-option *ngIf="!allowedPaymentMethods || allowedPaymentMethods.sofort"  [value]="types.sofort">
        <div fxLayout="row">
          <div class="payment-img-container">
            <img src="../../../../assets/img/payments/klarna.png" class="payment-img" />
          </div>
          <div class="payment-text">{{'ORDER.PAYMENT.FORM.'+ types.sofort | translate}}</div>
        </div>
      </mat-option>
      <mat-option *ngIf="!allowedPaymentMethods || allowedPaymentMethods.creditcard"  [value]="types.creditcard">
        <div fxLayout="row">
          <div class="payment-img-container">
            <img src="../../../../assets/img/payments/visa.jpg" class="payment-img" />
          </div>
          <div class="payment-text">{{'ORDER.PAYMENT.FORM.'+ types.creditcard | translate}}</div>
        </div>
      </mat-option>
      <mat-option *ngIf="!allowedPaymentMethods || allowedPaymentMethods.cashOnDelivery"  [value]="types.cashOnDelivery">
        <div fxLayout="row">
          <div class="payment-img-container">
            <img src="../../../../assets/img/payments/nachnahme.png" class="payment-img" />
          </div>
          <div class="payment-text">{{'ORDER.PAYMENT.FORM.'+ types.cashOnDelivery | translate}}</div>
        </div>
      </mat-option>
      <mat-option *ngIf="!allowedPaymentMethods || allowedPaymentMethods.free"  [value]="types.free">
        <div fxLayout="row">
          <div class="payment-img-container">

          </div>
          <div class="payment-text">{{'ORDER.PAYMENT.FORM.'+ types.free | translate}}</div>
        </div>

      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div *ngIf="currentType=='VOUCHER'">
  <mat-form-field>
    <input matInput [(ngModel)]="voucherCode" [disabled]="disabled" #voucherCodeModel="ngModel" [placeholder]="'ORDER.PAYMENT.FORM.VOUCHER_CODE' | translate"
      minlength="6" >
  </mat-form-field>
  <button mat-raised-button type="button" id="button-validate-voucher" color="primary" [disabled]="voucherCodeModel.invalid || disabled" (click)="validateVoucher()">
    {{"ORDER.PAYMENT.FORM.VALIDATE_VOUCHER" | translate}}
  </button>
</div>
